import { ColoredCell, RowProps, ResultsRow } from 'features/shared/ui/Table';
import React from 'react';
import { parallels, PercentsRowProps } from 'features/monitoring/models';
import TableRowWithTooltip from 'features/shared/TableRowWithTooltip';

type Props = RowProps &
  PercentsRowProps & {
    showSchool: boolean;
  };

export const Row = (props: Props) => (
  <ResultsRow noResults={props.noResults} lowResults={props.lowResults}>
    <td style={{ paddingLeft: '16px', textAlign: 'start' }}>
      <TableRowWithTooltip>{props.location}</TableRowWithTooltip>
    </td>
    {props.showSchool && (
      <td style={{ paddingLeft: '16px', textAlign: 'start' }}>
        <TableRowWithTooltip>{props.school}</TableRowWithTooltip>
      </td>
    )}
    <td>{props.registeredStudentsCount}</td>
    <td>{props.testedStudentsCount}</td>
    {parallels.map((parallel) => (
      <ColoredCell>{props.percentsByParallels[parallel] || 0}</ColoredCell>
    ))}
    <ColoredCell>{props.averagePercent}</ColoredCell>
  </ResultsRow>
);
